<template>
  <div class="d-flex flex-row">
    <div class="flex-item-input mr-2">
      <b-form-textarea
        class="flex-item--full"
        v-model="en"
        v-if="locale === 'en'"
        rows="6"
        no-resize
        width="100px"
        @keyup="handleKeyUp"
      ></b-form-textarea>
      <b-form-textarea
        class="flex-item--full"
        v-model="zh"
        v-else-if="locale === 'zh'"
        rows="6"
        no-resize
        @keyup="handleKeyUp"
      ></b-form-textarea>
      <b-form-textarea
        class="flex-item--full"
        v-model="km"
        v-else-if="locale === 'km'"
        rows="6"
        no-resize
        @keyup="handleKeyUp"
      ></b-form-textarea>
      <b-form-textarea
        class="flex-item--full"
        v-model="vi"
        v-else-if="locale === 'vi'"
        rows="6"
        no-resize
        @keyup="handleKeyUp"
      ></b-form-textarea>
    </div>
    <div>
      <b-form-select
        v-model="locale"
        :options="locales"
        :style="{
          minWidth: '72px',
          width: 'auto',
          maxWidth: '120px',
        }"
      ></b-form-select>
    </div>
  </div>
</template>

<script>
import {
  BCardText,
  BFormCheckbox,
  BFormInput,
  BFormSelect,
  BFormTextarea,
} from "bootstrap-vue";
import _isEqual from "lodash/isEqual";

export default {
  components: {
    BCardText,
    BFormCheckbox,
    BFormInput,
    BFormSelect,
    BFormTextarea,
  },
  props: {
    id: {
      type: String,
      default: "",
      required: false,
    },
    value: {
      type: Object,
      default: {
        en: null,
        zh: null,
        km: null,
        vi: null,
      },
    },
  },
  watch: {
    value(newValue) {
      if (_isEqual(this.mappedReturnValue, newValue)) return;
      this.mapLocalesToData();
    },
    mappedReturnValue(newValue) {
      if (_isEqual(this.value, newValue)) return;
      this.$emit("input", newValue);
    },
  },
  data: () => ({
    locale: "en",
    locales: [
      { value: "en", text: "English" },
      { value: "zh", text: "中文" },
      { value: "km", text: "ភាសាខ្មែរ" },
      { value: "vi", text: "Tiếng Việt" },
    ],
    en: null,
    zh: null,
    km: null,
    vi: null,
  }),
  methods: {
    handleKeyUp() {
      this.$emit("update:textEditor", this.value);
    },
    mapLocalesToData() {
      const { en, zh, km, vi } = this.value;
      this.en = en;
      this.zh = zh;
      this.km = km;
      this.vi = vi;
    },
  },

  computed: {
    mappedReturnValue() {
      return {
        en: this.en,
        zh: this.zh,
        km: this.km,
        vi: this.vi,
      };
    },
  },
  mounted() {
    this.mapLocalesToData();
  },
};
</script>

<style lang="scss" scoped>
.input--time {
  width: auto !important;
  max-width: 80px !important;
}

.text-editor {
}

.text-editor--en {
  display: inherit;
}

.text-editor--zh {
  display: none;
}

.text-editor--km {
  display: none;
}
</style>
